export default __webpack_public_path__ + "static/media/Sierra Leone.a3a873a9.png";